export const messages = {
  en: {
    meterTypeManage: {
      title: 'Meter Type Management',
      typeId: 'Meter Type ID',
      typeName: 'Name',
      remark: 'Description',
      createTime: 'Create Time',
      operation: 'Operation',
      tip: 'If a property has multiple electricity/water meters, you can create multiple types here, e.g. Electricity Meter 1, Electricity Meter 2',
      addTitle: 'Add Meter Type',
      editTitle: 'Edit Meter Type',
      deleteTitle: 'Confirm Operation',
      deleteConfirm: 'Are you sure to delete this meter type?',
      deleteTip: 'This operation cannot be undone!',
      typeNamePlaceholder: 'Required, please enter name',
      remarkPlaceholder: 'Required, please enter description',
      typeNameRequired: 'Name is required',
      typeNameMaxLength: 'Name cannot exceed 12 characters',
      remarkRequired: 'Description is required',
      remarkMaxLength: 'Description cannot exceed 200 characters',
      typeIdRequired: 'Meter Type ID is required',
      addSuccess: 'Added successfully',
      addFailed: 'Failed to add',
      editSuccess: 'Updated successfully',
      editFailed: 'Failed to update',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      fetchError: 'Failed to fetch data',
      page: {
        title: 'Meter Type Management',
        subtitle: 'Maintain the meter types used when reading room meters',
        empty: 'No meter types found',
        loadFailed: 'Failed to load meter types, please retry'
      }
    }
  },
  zh: {
    meterTypeManage: {
      title: '抄表类型管理',
      typeId: '抄表类型ID',
      typeName: '名称',
      remark: '说明',
      createTime: '创建时间',
      operation: '操作',
      tip: '如果一个房屋有多个电表水表可以在这里新建多个 比如电表1 电表2',
      addTitle: '添加抄表类型',
      editTitle: '修改抄表类型',
      deleteTitle: '确认操作',
      deleteConfirm: '确定删除该抄表类型吗？',
      deleteTip: '此操作不可撤销！',
      typeNamePlaceholder: '必填，请填写名称',
      remarkPlaceholder: '必填，请填写说明',
      typeNameRequired: '名称不能为空',
      typeNameMaxLength: '名称不能超过12个字符',
      remarkRequired: '说明不能为空',
      remarkMaxLength: '说明不能超过200个字符',
      typeIdRequired: '抄表类型ID不能为空',
      addSuccess: '添加成功',
      addFailed: '添加失败',
      editSuccess: '修改成功',
      editFailed: '修改失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      fetchError: '获取数据失败',
      page: {
        title: '抄表类型管理',
        subtitle: '维护房屋抄表时使用的抄表类型',
        empty: '暂无抄表类型',
        loadFailed: '抄表类型加载失败，请重试'
      }
    }
  }
}